import React, { useEffect, useState } from "react";
import { Link, Navigate, Route, Routes, useLocation, useNavigate, useParams,} from "react-router-dom";
import ProjectTab from "../../components/ProjectModule/project/ProjectTab";
import TaskTab from "../../components/ProjectModule/task/TaskTab";
import SubTaskList from "../../components/ProjectModule/task/Subtasklist";
import IssueTab from "../../components/ProjectModule/issues/IssueTab";
import TimeSheetTab from "../../components/ProjectModule/timesheet/TimeSheetTab";
import MilestoneTab from "../../components/ProjectModule/milestones/MilestoneTab";
import UserTab from "../../components/ProjectModule/user/UserTab";
import BudgetTab from "../../components/budget/ButgetTab";
import ProjectEarningsTab from "../../components/ProjectModule/earnings/ProjectEarningsTab";
import EmployeeBudgetView from "../../components/budget/EmployeeBudgetView";
import { fetchEntityById } from "../../apis/apiService.js";
import { IoIosArrowBack } from "react-icons/io";
import Loader from "../../components/common/Loader.js";
import { setprojectName, setUserNamesByProjects } from "../../selectSlice.js";
import { useDispatch, useSelector } from "react-redux";
import Pagenotfound from "../../components/common/Pagenotfound.js";
import { useFetchUserAccessedProjectsQuery } from "../../slice/logdetailSlice";

const ProjectDetail = () => {
  const { id } = useParams();
  const location = useLocation();
  const [projects, setProject] = useState(null);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const isActiveTab = (path) => location.pathname.includes(path);

  const fetchProjectDetails = async () => {
    try {
      setLoading(true); // Start loading state
      const response = await fetchEntityById("projects", id);
      // //console.log()("project_view_by_id", response);

      setProject(response.data);
      const project_id = response.data.project_id;
      const billingType = response.data.billing_type;
      //console.log()("project_name :", response.data.title);
      dispatch(setprojectName(response.data.title));
      await localStorage.setItem("project_id", project_id);
      await fetchProjectUsers();
    } catch (err) {
      setError(err.message || "Failed to fetch project details");
    } finally {
      setLoading(false); // End loading state
    }
  };
  const fetchProjectUsers = async () => {
    try {
      const project_id = await localStorage.getItem("project_id");
      const response = await fetchEntityById("usersInProjects", project_id);
      // //console.log()("usersInProjects", response.data);
      dispatch(setUserNamesByProjects(response?.data));
    } catch (error) {
      console.error("Error fetching project user name:", error);
    }
  };
  useEffect(() => {
    if (id) {
      fetchProjectDetails();
    }
  }, [id]);
  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  const { name, role: login_user_role } = login_user || {};
  const login_user_id = login_user?.id || login_user?.user_id;

  const { data: userAccessedProjects = [], isLoading: isUserAccessedLoading } = useFetchUserAccessedProjectsQuery(undefined, {
    skip: login_user_role !== "MANAGER",
  });

  const canViewBudget = React.useMemo(() => {
    if (login_user_role === "ADMIN") return true;
    if (login_user_role === "MANAGER") {
      const isAssigned = Array.isArray(userAccessedProjects) && userAccessedProjects.some(
        (p) => String(p.project_id) === String(id)
      );
      const isOwner = projects?.project_manager_id != null && Number(projects.project_manager_id) === Number(login_user_id);
      return Boolean(isAssigned || isOwner);
    }
    return false;
  }, [login_user_role, userAccessedProjects, id, projects, login_user_id]);

  // Employees see the Budget tab, but only the employee budget view (not BudgetTab).
  const isEmployee = login_user_role === "EMPLOYEE";

  // End Function to Fetch the projectValues
  if (loading || (login_user_role === "MANAGER" && isUserAccessedLoading && !userAccessedProjects?.length))
    return (
      <>
        <Loader />
      </>
    );
  if (error) {
    return <Pagenotfound />;
  }

  const handleBackClick = () => {
    navigate(-1); // Navigates to the previous page
  };

  return (
    <div className="bg-white p-3 detailpage">
      {!isActiveTab("subTaskList") && (
        <div className=" d-flex text-rgba-gray align-items-center">
          <button className="R_btn" onClick={handleBackClick}>
            <IoIosArrowBack className="text-rgba-gray" size={20} />
          </button>
          <ul className="nav nav-tabs" id="myTab" role="tablist">
            <li className="nav-item pe-4" role="presentation">
              {(login_user_role === "ADMIN" ||
                login_user_role === "MANAGER" ||
                login_user_role === "EMPLOYEE") && (
                  <Link
                    to="details"
                    className={`nav-link ${isActiveTab("details") ? "active" : ""}`}
                  >
                    Project Details
                  </Link>
                )}
            </li>
            <li className="nav-item pe-4" role="presentation">
              <Link
                to="tasks"
                className={`nav-link ${isActiveTab("tasks") ? "active" : ""}`}
              >
                Tasks
              </Link>
            </li>
            <li className="nav-item pe-4" role="presentation">
              <Link
                to="issues"
                className={`nav-link ${isActiveTab("issues") ? "active" : ""}`}
              >
                Issues
              </Link>
            </li>
            {(canViewBudget || isEmployee) && (
              <li className="nav-item pe-4" role="presentation">
                <Link
                  to="budget"
                  className={`nav-link ${isActiveTab("budget") ? "active" : ""}`}
                >
                  Budget
                </Link>
              </li>
            )}
            {canViewBudget && (
              <li className="nav-item pe-4" role="presentation">
                <Link
                  to="earnings"
                  className={`nav-link ${isActiveTab("earnings") ? "active" : ""}`}
                >
                  Earnings
                </Link>
              </li>
            )}
            <li className="nav-item pe-4" role="presentation">
              <Link
                to="milestones"
                className={`nav-link ${isActiveTab("milestones") ? "active" : ""
                  }`}
              >
                Milestones
              </Link>
            </li>
            <li className="nav-item pe-4" role="presentation">
              <Link
                to="users"
                className={`nav-link ${isActiveTab("users") ? "active" : ""}`}
              >
                Users
              </Link>
            </li>
            <li className="nav-item pe-4" role="presentation">
              <Link
                to="timesheet"
                className={`nav-link ${isActiveTab("timesheet") ? "active" : ""}`}
              >
                Timesheet
              </Link>
            </li>
          </ul>
        </div>
      )}

      {/* Routes to render corresponding components */}
      <div className="tab-content" id="myTabContent">
        {/* <Routes>
          <Route
            path="details"
            element={<ProjectTab projectDetail={projects} />}
          />
          <Route path="tasks" element={<TaskTab ProjectID={id} />} />
          <Route path="issues" element={<IssueTab ProjectID={id} />} />
          <Route path="budget" element={<BudgetTab />} />
          <Route path="milestones" element={<MilestoneTab />} />
          <Route path="users" element={<UserTab />} />
          <Route path="timesheet" element={<TimeSheetTab />} />
          <Route path="board" element={<Board />} />
          <Route path="/" element={<Navigate to="details" replace />} />
          <Route path="*" element={<Pagenotfound />} />
        </Routes> */}
        <Routes>
          {(login_user_role === "ADMIN" ||
            login_user_role === "MANAGER" ||
            login_user_role === "EMPLOYEE") && (
              <Route
                path="details"
                element={<ProjectTab projectDetail={projects} />}
              />
            )}

          <Route path="tasks" element={<TaskTab ProjectID={id} />} />
          <Route path="subTaskList/:id" element={<SubTaskList />} />
          <Route path="issues" element={<IssueTab ProjectID={id} />} />
          {canViewBudget ? (
            <Route path="budget" element={<BudgetTab />} />
          ) : isEmployee ? (
            // Employees get only their own budget view, never the full BudgetTab.
            <Route path="budget" element={<EmployeeBudgetView />} />
          ) : (
            <Route path="budget" element={<Pagenotfound />} />
          )}

          {canViewBudget && (
            <Route path="earnings" element={<ProjectEarningsTab projectDetail={projects} projectId={id} />} />
          )}
          <Route path="milestones" element={<MilestoneTab />} />
          <Route path="users" element={<UserTab />} />
          <Route path="timesheet" element={<TimeSheetTab />} />
          <Route index element={<Navigate to="details" replace />} />
          <Route path="*" element={<Pagenotfound />} />
        </Routes>
      </div>
    </div>
  );
};

export default ProjectDetail;
